import { Chip, useMatchScreenWidth } from '@keplerco/core';
import React from 'react';
import { EmptyState } from '../../../../../components/general/empty-state/empty-state';
import { OptionButton } from '../../../../../components/general/option-button/option-button';
import Accordion from '../../../../../components/accordion/accordion';
import styles from './assessment-progress.module.css';
import { CompletionStatusChip } from '../../../../../components/chips/completion-status.chip';
import { AssessmentAssignee } from '../../../../../models/overmind/assessment-analytics';
import { getStatusColour } from './assessment-progress-helpers';
import { AssessmentAssigneeListItemLayout, AssessmentReviewerListItemLayout } from '../../../../../components/assessment/assessment-entity-list-item.layout';
import { PeerAssessmentAssigneeResponse } from '../../../../../overmind/actions';

export function AssessmentProgressAccordion({ assignee }: { assignee: AssessmentAssignee; }) {
  const isMobile = useMatchScreenWidth('mobile');

  const mappedAssignee: PeerAssessmentAssigneeResponse = {
    learnerSlug: assignee.learnerSlug,
    fullName: assignee.fullName,
    roles: assignee.roles,
    department: assignee.department,
    team: assignee.team,
    email: assignee.email,
    reviewers: assignee.reviewers.map(reviewer => ({
      learnerSlug: reviewer.learnerSlug,
      fullName: reviewer.fullName,
      roles: reviewer.roles,
      isManager: reviewer.isManager,
    })),
    companySkills: [],
  };

  function AccordionHeader() {
    return (
      <div className={styles.accordionHeader}>
        <AssessmentAssigneeListItemLayout assignee={mappedAssignee}>
          <CompletionStatusChip completionStatus={assignee.completionStatus} />
        </AssessmentAssigneeListItemLayout>
      </div>
    );
  }

  return (
    <Accordion header={<AccordionHeader />} borderLeftColor={getStatusColour(assignee.completionStatus)}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
        {!!assignee.reviewers.length ? (
          <>
            <h6>{`The following people will assess ${assignee.fullName}`}</h6>
            {assignee.reviewers.map(reviewer => {
              const mappedReviewer = {
                learnerSlug: reviewer.learnerSlug,
                fullName: reviewer.fullName,
                roles: reviewer.roles,
                isManager: reviewer.isManager,
              };
              return (
                <OptionButton style={{ width: '100%', display: 'grid', gridTemplateColumns: isMobile ? '1fr' : '1fr 1fr 150px', textAlign: 'start' }} key={reviewer.learnerSlug}>
                  <AssessmentReviewerListItemLayout reviewer={mappedReviewer}>
                    {reviewer.learnerSlug === assignee.learnerSlug && <Chip customTheme={{ backgroundColor: 'card_2', borderColor: 'blue', color: 'text' }}>Self</Chip>}
                    {reviewer.isManager && <Chip customTheme={{ backgroundColor: 'card_2', borderColor: 'blue', color: 'text' }}>Manager</Chip>}
                    <div style={{ whiteSpace: 'nowrap' }}>
                      <CompletionStatusChip completionStatus={reviewer.completionStatus} />
                    </div>
                  </AssessmentReviewerListItemLayout>
                </OptionButton>
              );
            })}
          </>
        ) : (
          <EmptyState title="" subtitle={`No assessors selected`} />
        )}
      </div>
    </Accordion>
  );
}

